import {useUserDevice} from "@pg-mono/user-device";

import {IMapOfferSidebar} from "../map/types/MapOfferSidebar";

interface IParams {
    offer: IMapOfferSidebar | undefined;
    isOpen: boolean;
    isQuickViewOpen: boolean;
}

/**
 * True when the mobile map offer panel shows its offer view, which has its own filters entry: the panel is open, has an offer
 * (`useMapPanelOffer`, the same value the view passes to MapOfferPreview) and the quick view is not covering the offer view.
 * The map view evaluates it in the same render as the panel, so the shared filters entry test id moves between them within one
 * React commit. `isQuickViewOpen` mirrors the panel's own quick view state (set in the same event handler).
 */
export const useIsMapOfferPanelFiltersEntryActive = ({offer, isOpen, isQuickViewOpen}: IParams): boolean => {
    const {isMobile} = useUserDevice();

    return Boolean(isMobile && offer && isOpen && !isQuickViewOpen);
};
import {useUserDevice} from "@pg-mono/user-device";

import {IMapOfferSidebar} from "../map/types/MapOfferSidebar";

interface IParams {
    offer: IMapOfferSidebar | undefined;
    isOpen: boolean;
    isQuickViewOpen: boolean;
}

/**
 * True when the mobile map offer panel shows its offer view, which has its own filters entry: the panel is open, has an offer
 * (`useMapPanelOffer`, the same value the view passes to MapOfferPreview) and the quick view is not covering the offer view.
 * The map view evaluates it in the same render as the panel, so the shared filters entry test id moves between them within one
 * React commit. `isQuickViewOpen` mirrors the panel's own quick view state (set in the same event handler).
 */
export const useIsMapOfferPanelFiltersEntryActive = ({offer, isOpen, isQuickViewOpen}: IParams): boolean => {
    const {isMobile} = useUserDevice();

    return Boolean(isMobile && offer && isOpen && !isQuickViewOpen);
};
